<template>
    <section class="left_menu">
        <nav class="left_gnb">
            <ul class="depth_01">
                <li
                    v-for="(menu, idx) in menus"
                    :key="idx"
                    :class="[menu.isActive ? 'active' : '']"
                    @click="!menu.child ? router.push({ name: menu.path }) : ''"
                >
                    <template
                        v-if="
                            menu.isHasAuth === undefined ||
                            (menu.isHasAuth === false && user.userInfo.auth !== 8 && user.userInfo.auth !== 7 && menu.path !== 'desk_for_7') ||
                            (menu.isHasAuth === true && user.userInfo.auth === 8) ||
                            (menu.isHasAuth === false && user.userInfo.auth === 7 && menu.path === 'desk_for_7')
                        "
                    >
                        <div>
                            <span class="menu_icon">
                                <img v-if="!menu.isActive" :src="menu.thumbnailPath" alt="" />
                                <img v-else :src="menu.thumbnailPathActive" alt="" />
                            </span>
                            <p v-html="menu.name"></p>
                        </div>

                        <ul class="depth_02" v-show="true" v-if="menu.child">
                            <li
                                v-for="(childMenu, childIdx) in menu.child"
                                :key="childIdx"
                                :class="{ active: childMenu.isActive }"
                                @click="router.push({ name: childMenu.path })"
                            >
                                {{ childMenu.name }}
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </nav>
    </section>
</template>

<script lang="ts">
    import {
        apiService,
        onMounted,
        reactive,
        router,
        userStore,
        returnCode,
        globalStore,
        watch,
        types,
        useRoute,
        ref,
        onUnmounted,
    } from "@/BaseComponent";

    export default {
        setup() {
            const menus = reactive([
                {
                    path: "client",
                    name: "전체 내담자 목록",
                    isActive: false,
                    thumbnailPath: "img/client.png",
                    thumbnailPathActive: "img/client_w.png",
                },
                {
                    path: "new",
                    name: "신규 상담",
                    isActive: false,
                    thumbnailPath: "img/newCounsel.png",
                    thumbnailPathActive: "img/newCounsel_w.png",
                    child: [
                        { path: "newClient", name: "신규 상담", isActive: false },
                        { path: "myClient", name: "담당 내담자 목록", isActive: false },
                    ],
                },
                {
                    path: "counsel",
                    name: "상담 목록",
                    isActive: false,
                    thumbnailPath: "img/counselList.png",
                    thumbnailPathActive: "img/counselList_w.png",
                    child: [
                        { path: "counsel", name: "전체 목록", isActive: false },
                        { path: "myCounsel", name: "내가 작성한 목록", isActive: false },
                        { path: "record", name: "상담 녹취록", isActive: false },
                        { path: "temporary", name: "임시저장 목록", isActive: false },
                    ],
                },
                {
                    path: "activity",
                    name: "예방홍보네트워크활동",
                    isActive: false,
                    thumbnailPath: "img/activity.png",
                    thumbnailPathActive: "img/activity_w.png",
                },
                {
                    path: "complain",
                    name: "민원",
                    isActive: false,
                    thumbnailPath: "img/complaint.png",
                    thumbnailPathActive: "img/complaint_w.png",
                },
                {
                    path: "item",
                    name: "홍보 물품 관리",
                    isActive: false,
                    thumbnailPath: "img/item.png",
                    thumbnailPathActive: "img/item_w.png",
                },
                {
                    path: "statistics",
                    name: "통계",
                    isActive: false,
                    thumbnailPath: "img/statistics.png",
                    thumbnailPathActive: "img/statistics_w.png",
                    child: [
                        { path: "statisticsCommon", name: "통계", isActive: false },
                        { path: "statisticsActivity", name: "예방홍보네트워크", isActive: false },
                    ],
                },
                {
                    path: "myPage",
                    name: "비밀번호 변경",
                    isActive: false,
                    isHasAuth: false,
                    thumbnailPath: "img/lock.png",
                    thumbnailPathActive: "img/lock_w.png",
                },
                {
                    path: "desk_for_7",
                    name: "DESK",
                    isActive: false,
                    isHasAuth: false,
                    thumbnailPath: "img/desk.png",
                    thumbnailPathActive: "img/desk_w.png",
                    child: [
                        { path: "myPage", name: "비밀번호 변경", isActive: false },
                        { path: "newClntList", name: "신규내담자 확인", isActive: false },
                        { path: "newCnslList", name: "상담일지 승인", isActive: false },
                        { path: "accessRequestClient", name: "수정/삭제 승인(내담자)", isActive: false },
                        { path: "accessRequestCounsel", name: "수정/삭제 승인(상담일지)", isActive: false },
                    ],
                },
                {
                    path: "desk",
                    name: "DESK",
                    isActive: false,
                    isHasAuth: true,
                    thumbnailPath: "img/desk.png",
                    thumbnailPathActive: "img/desk_w.png",
                    child: [
                        { path: "manage", name: "상담원 관리", isActive: false },
                        { path: "newClntList", name: "신규내담자 확인", isActive: false },
                        { path: "newCnslList", name: "상담일지 승인", isActive: false },
                        { path: "accessRequestClient", name: "수정/삭제 승인(내담자)", isActive: false },
                        { path: "accessRequestCounsel", name: "수정/삭제 승인(상담일지)", isActive: false },
                    ],
                },
            ]);
            const user = userStore();
            const route = useRoute();
            const global = globalStore();
            const { changeCode } = returnCode();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,

                isLogin: false as boolean,

                menuOverFlag: false as boolean,
            });

            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const scrollY = ref(0);

            onMounted(async () => {
                checkLogin();

                checkMenu();
            });

            onUnmounted(() => {});

            watch(
                () => user.accessToken,
                () => {
                    checkLogin();
                },
            );

            watch(route, () => {
                checkMenu();
            });

            const checkMenu = () => {
                menus.forEach((menu) => {
                    const path = route.path.split("/")[1];
                    if (path.indexOf(menu.path) > -1) {
                        menu.isActive = true;
                    } else {
                        menu.isActive = false;
                    }

                    if (menu.child) {
                        menu.isActive = false;
                        menu.child.forEach((child) => {
                            if (route.name!.toString().indexOf(child.path) > -1) {
                                child.isActive = true;
                                menu.isActive = true;
                            } else {
                                child.isActive = false;
                            }
                        });
                    }
                });
            };

            const checkLogin = () => {
                if (user.isLogin()) {
                    state.isLogin = true;
                } else {
                    state.isLogin = false;
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            const resetMenuActive = () => {
                menus.forEach((menu) => {
                    menu.isActive = false;
                    const path = route.path.split("/")[1];
                    if (path === menu.path) menu.isActive = true;
                    // child가 있다면 확인
                    if (menu.child) {
                        menu.child.forEach((child) => {
                            if (route.name?.toString().includes(child.path)) {
                                child.isActive = true;
                                menu.isActive = true;
                            } else {
                                child.isActive = false;
                            }
                        });
                    }
                });
            };

            return {
                state,
                route,
                userInfo,
                modal,
                openMenu,

                router,
                user,
                menus,
                resetMenuActive,
            };
        },
    };
</script>
<style scoped>
    .left_menu nav ul.depth_01 > li {
        position: relative;
    }
    .left_menu nav ul.depth_01 > li > ul.depth_02 {
        display: flex;
        flex-direction: column;
        margin: 0;
        justify-content: center;
        border-radius: 10px;
        background-color: #f7f7f9;
        transition-duration: 0.3s;
        opacity: 0;
        visibility: hidden;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: 0;
        min-width: 170px;
        width: max-content;
        padding: 0px 10px;
        box-shadow: 0px 0px 10px 0px #0000001a;
    }

    .left_menu nav ul.depth_01 li:hover ul.depth_02 {
        transform: translate(170px, -50%);
        opacity: 1;
        visibility: visible;
    }

    .left_menu nav ul.depth_02 li {
        padding: 8px 5px;
        border-radius: 10px;
        color: #252525;
        text-align: center;
        margin-bottom: 0;
        cursor: pointer;
    }

    .left_menu nav ul.depth_02 li.active {
        background-color: #31a6d8;
        color: #f7f7f9;
        font-weight: bold;
    }
    .left_menu nav ul.depth_01 > li span {
        margin-right: 5px !important;
    }

    .left_menu nav ul.depth_01 > li > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        border-radius: 10px;
        padding: 15px 0 15px;
        gap: 3px;
        width: 170px;
    }

    .left_menu nav ul.depth_01 > li.active > div {
        background-color: #31a6d8;
    }
    .left_menu nav ul.depth_01 > li > div > p {
        font-family: Noto Sans KR;
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        text-align: center;
        margin-top: 4px;
    }

    .left_menu nav ul.depth_01 > li.active > div > p {
        color: white;
        font-weight: bold;
    }

    .menu_icon img {
        height: 25px;
        width: 25px;
    }

    .left_menu {
        width: auto !important;
        background: none !important;
        align-items: flex-start;
    }
</style>
